import * as React from 'react';
import styled from 'styled-components';
import Button from '../../../components/Button';
import { HiringManager } from '../types';
import ShareWithHiringManagerInput from './ShareWithHiringManagerInput';

interface ShareWithHiringManagerFormProps {
    hiringManagers: HiringManager[];
    onUpdateHiringManagers: (hiringManagers: HiringManager[]) => void;
    onShare: (hiringManager: HiringManager) => void;
}

interface ShareWithHiringManagerFormState {
    showInvitationSentNotification: boolean;
}

const Layout = styled.div`
    input,
    ${Button} {
        display: block;
        margin-bottom: 0.5em;
    }
`;

const sortHiringManager: (h1: HiringManager, h2: HiringManager) => number = (h1, h2) => h1.seq - h2.seq;

class ShareWithHiringManagerForm extends React.Component<
    ShareWithHiringManagerFormProps,
    ShareWithHiringManagerFormState
> {
    constructor(props: ShareWithHiringManagerFormProps) {
        super(props);
        this.handleOnShare = this.handleOnShare.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onNewHiringManager = this.onNewHiringManager.bind(this);
    }

    private handleOnShare() {
        this.props.onShare(this.props.hiringManagers[0]);
    }

    private onChange(hiringManager: HiringManager, email: string) {
        const newHMs = this.props.hiringManagers.filter(hm => hm !== hiringManager);
        newHMs.push({ email, seq: hiringManager.seq });
        this.props.onUpdateHiringManagers(newHMs);
    }

    private onNewHiringManager(hiringManager: HiringManager) {
        const newHMs = Array.from(this.props.hiringManagers);
        newHMs.push(hiringManager);
        this.props.onUpdateHiringManagers(newHMs);
    }

    public render() {
        return (
            <Layout>
                {this.props.hiringManagers.sort(sortHiringManager).map((hm, index) => (
                    <ShareWithHiringManagerInput
                        hiringManager={hm}
                        onChange={(hiringManager: HiringManager) => {
                            this.onChange(hm, hiringManager.email);
                        }}
                        key={index}
                    />
                ))}
                <ShareWithHiringManagerInput
                    hiringManager={{ email: '', seq: this.props.hiringManagers.length }}
                    onChange={this.onNewHiringManager}
                />
                <Button onClick={this.handleOnShare}>send e-mail</Button>
            </Layout>
        );
    }
}

export default ShareWithHiringManagerForm;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/ShareWithHiringManagerForm.tsx